module.exports = __webpack_public_path__ + "static/media/17.44f72089.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/17.jpg
// module id = 178
// module chunks = 0